<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>角色管理</span>
            <a class="icon-index-1 jm-fr" @click="openFormDialog">
              <el-button
                type="primary"
                size="medium">创建角色</el-button>
            </a>
          </div>

          <el-form
            :inline="true"
            :model="searchData">
            <el-form-item label="角色ID">
              <el-input v-model="searchData.roleid"/>
            </el-form-item>
            <el-form-item label="角色名称">
              <el-input v-model="searchData.rolename"/>
            </el-form-item>
            <el-form-item label="所属国家">
              <el-select
                class="jm-input220"
                clearable
                filterable
                v-model="searchData.country">
                <el-option v-for="item in ds.countries" :key="item.id" :value="item.id" :label="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="() => this.refresh = true">查询</el-button>
            </el-form-item>
          </el-form>
          <jm-tableList
            url="/index/Power/group"
            no-pagination
            :refresh.sync="refresh"
            :search-data="searchData">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="280">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="openFormDialog(scope.row)">编辑</el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEditRules(scope)">编辑权限</el-button>
                <el-button
                  size="small"
                  type="warning"
                  :disabled="!!scope.row.disabled"
                  @click="openListDialog(scope)">人员管理</el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="handleDelete(scope)">删除</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>

    <!--编辑弹窗 start-->
    <el-dialog
      class="drawer"
      top="0"
      width="500px"
      :title="formData.roleid ? '编辑角色' : '添加角色'"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible">
      <el-form
        ref="userGroup"
        :model="formData"
        :rules="rules"
        style="padding-right:30px"
        label-width="100px">
        <el-form-item label="角色名称" prop="name">
          <el-input clearable v-model="formData.name"/>
        </el-form-item>
        <el-form-item label="角色标识">
          <el-input clearable v-model="formData.sign"/>
        </el-form-item>
        <el-form-item label="所属国家">
          <el-select clearable filterable v-model="formData.country">
            <el-option
              v-for="item in ds.countries"
              :key="item.id"
              :value="item.id"
              :label="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-select clearable v-model="formData.department" placeholder="请选择">
            <el-option
              v-for="item in ds.departments"
              :key="item.id"
              :label="item.name"
              :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="职务类型">
          <el-select clearable v-model="formData.station" placeholder="请选择">
            <el-option
              v-for="item in ds.stations"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" placeholder="请输入内容" v-model="formData.description"
                    :autosize="{ minRows: 2, maxRows: 10 }"/>
        </el-form-item>
        <el-form-item label="排序">
          <el-input type="number" class="jm-input135" v-model="formData.listorder"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            active-text="禁用"
            inactive-text="启用"
            :active-value="1"
            :inactive-value="0"
            v-model="formData.disabled"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handelSave">
          {{ formData.roleid ? '保存' : '立即创建' }}
        </el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗 end-->

    <!--人员弹窗 start-->
    <el-dialog
      class="drawer1"
      width="600px"
      title="人员管理"
      :lock-scroll="!true"
      :visible.sync="dialogListVisible">
      <el-input type="text" v-model="admin_key" placeholder="请输入管理员UID或名字" style="width:70%;margin-bottom:12px;">
        <el-button slot="append" type="primary" @click="addGroupAdmin" icon="el-icon-plus">添加</el-button>
      </el-input>

      <jm-tableList
        url="/index/Power/groupAdmin"
        :search-data="{ id: currentRoleId }"
        size="small"
        no-pagination
        :refresh.sync="dialogListRefresh">
        <el-table-column
          slot="lastColumn"
          label="操作"
          width="140">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click="delGroupAdmin(scope)">移除</el-button>
          </template>
        </el-table-column>
      </jm-tableList>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogListVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗 end-->
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

const defaultFormData = {
  roleid: '',
  name: '',
  sign: '',
  description: '',
  listorder: 0,
  disabled: 0,
  country: null,
  department: null,
  station: null,
};

export default {
  data() {
    return {
      refresh: false,
      disabled: false,
      searchData: {
        roleid: '',
        rolename: '',
        country: ''
      },
      dialogFormVisible: false,
      ds: {
        departments: [],
        stations: [],
        countries: [],
      },
      formData: {},
      currentRoleId: '',
      dialogListVisible: false,
      dialogListRefresh: false,
      admin_key: '',
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect
  },
  methods: {
    refreshList() {
      this.refresh = true;
    },
    handelSave() {
      this.formData.roleid ? this.saveUserGroup() : this.createUserGroup();
    },
    handleDelete(scope) { // 删除
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/Power/groupDel',
          data: {
            id: scope.row.roleid
          },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.refreshList();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleEditRules(scope) {
      this.$router.push({
        name: 'groupRules',
        params: {
          id: scope.row.roleid
        }
      });
    },
    createUserGroup() {
      this.$refs.userGroup.validate((valid) => {
        if (valid) {
          this.$http._post({
            url: '/index/Power/groupAdd',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              this.$message.success('创建成功!');
              this.dialogFormVisible = false;
              this.refreshList();
            }
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    saveUserGroup() {
      this.$refs.userGroup.validate((valid) => {
        if (valid) {
          this.$confirm('此操作将永久改变该角色信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http._post({
              url: '/index/Power/groupEdit',
              data: this.formData,
            }).then((res) => {
              if (res.result === 0) {
                this.$message.success('编辑成功!');
                this.dialogFormVisible = false;
                this.refreshList();
              }
            });
          }).catch(() => {
            this.$message.info('已取消编辑');
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    openFormDialog(formData) {
      if (formData) {
        this.formData = Object.assign({}, formData);
      } else {
        this.formData = Object.assign({}, defaultFormData);
      }

      // 修复默认值
      ['department', 'station', 'country'].forEach((key) => {
        if (!this.formData[key]) {
          console.info(key);
          this.formData[key] = '';
        }
      });
      this.dialogFormVisible = true;
    },
    openListDialog(scope) { // 编辑
      this.dialogListVisible = true;
      this.currentRoleId = scope.row.roleid;
      this.dialogListRefresh = true;
    },
    addGroupAdmin() {
      if (this.admin_key === '') {
        this.$message.error('请输入被添加管理员信息！');
        return false;
      }
      this.$http._post({
        url: '/index/Power/addGroupAdmin',
        data: {
          roleid: this.currentRoleId,
          admin_key: this.admin_key,
        },
      }).then((res) => {
        if (res.result === 0) {
          this.$message.success('添加成功!');
          this.admin_key = '';
          this.dialogListRefresh = true;
        }
      });
    },
    delGroupAdmin(scope) { // 删除
      this.$confirm('此操作将删除此管理员该角色, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/Power/groupAdminDel',
          data: {
            roleid: this.currentRoleId,
            userid: scope.row.userid
          },
        }).then((res) => {
          if (res.result === 0) {
            this.$message.success('删除成功!');
            this.dialogListRefresh = true;
          }
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
  },
  computed: {
  },
  mounted() {
    this.$http._get({ url: '/index/Power/searchDs' })
      .then((res) => {
        if (res.result === 0) {
          this.ds = res.data;
        }
      });
  },
};
</script>

<style scoped>
/* 抽屉样式 */
.drawer >>> .el-dialog {
  position: absolute !important;
  right: 0;
  height: 100%;
}
.drawer >>> .el-dialog__body {
  height: calc(100% - 140px);
}
.drawer >>> .dialog-footer {
  position: sticky;
  bottom: 10px;
}
</style>
